import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { GenericConfigContext } from "/contexts/generic-config-context";
import { ADDON_CONFIG, ADDONS } from "constants/addons";
const VibePricingFeature = ({ addon, selectedUnit = 10 })=>{
    const { translateOrTranslateWithParam } = useContext(GenericConfigContext);
    const vibeConfig = ADDON_CONFIG[ADDONS.VIBE];
    if (!addon) {
        return null;
    }
    const featureText = translateOrTranslateWithParam({
        key: vibeConfig.featureTextKey,
        param: selectedUnit
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "feature",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "name-and-label",
            children: [
                /*#__PURE__*/ _jsx("span", {
                    children: featureText
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "icon",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/static/img/vibe/vibe_icon.svg",
                        alt: vibeConfig.displayName
                    })
                })
            ]
        })
    });
};
export default VibePricingFeature;
